module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Router#2-c94ee57b3462fb5845e8d015656a12d3.svg";